import {
  createAuthState,
  openAuthLink,
  PLATFORM_CONFIG,
  serverUrl,
} from "../AssistantDetails/Assistants.utils";

const handleCommonAuth = async ({
  assistantId,
  user,
  isConfigRequired,
  platformName,
  isOnboarding
}) => {
  const config = PLATFORM_CONFIG[platformName];

  if (!config) {
    console.error(`Unsupported platform: ${platformName}`);
    return;
  }
  if (!user) {
    console.error(`No existing user found`);
    return;
  }

  const entity = user;
  const fetchAndUpdateProfile = async () => {
    const state = createAuthState(entity, assistantId, isConfigRequired, isOnboarding);

    try {
      openAuthLink(`${serverUrl}/${config.authPath}/${state}`);
    } catch (error) {
      console.warn(
        `${platformName} profile fetch failed, redirecting to auth...`,
      );
    }
  };

  return fetchAndUpdateProfile();
};

export const handleMicrosoftAuth = async (params) => {
  return handleCommonAuth({ ...params, platformName: "microsoft" });
};

export const handleSlackAuth = async (params) => {
  return handleCommonAuth({ ...params, platformName: "slack" });
};

export const handleTrelloAuth = async (params) => {
  return handleCommonAuth({ ...params, platformName: "trello" });
};
